// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jJId","content":"styles_content__3tPjm"};